import React from 'react'
import Stylebutton from '../../../../components/buttons/stylebutton/Stylebutton'
import { post, Token } from '../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
function CreateKathegorieForm({setc, upd}) {
    const navigate = useNavigate();
    function create(name){
        let body = {};
        body.token = Token.get();
        body.action = "createKathegorie";
        body.name = name;
        let response = post(body,"/vergleiche/Sparten");
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        if (response == "OK"){
            setc(false);
            upd();
            return;
        }
        alert("Ein fehler ist aufgetreten!");
    }


  return (
<div style={{position: "absolute",zIndex: 99999, left: "50%", top: "50%",transform: "translate(-50%, -50%)", backgroundColor: "white", display: "flex",
              width: "40%",
              height: "30%",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
              flexDirection: "column",
              alignItems: "center"
              }}>
                  <div style={{color:"white",height: "15%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center", display: "flex",fontSize: "20px"}}>
                                  <p>Sparte Erstellen</p>
                        </div>
                  <div style={{width: "100%", backgroundColor: "transparent",height: "65%", display: "flex", alignItems: "center", justifyContent: "space-evenly"}}>
                  <input
                            type="text"
                            placeholder="Spartenname"
                            style={{
                              backgroundColor: '#fff',     // dunkler Hintergrund
                              color: 'black',               // weißer Text innen
                              border: '1px solid #3a3f54',    // dezente Umrandung
                              borderRadius: '8px',            // abgerundete Ecken
                              padding: '12px 16px',           // Innenabstand
                              fontSize: '16px',
                              outline: 'none',
                              width: '30%',
                              maxWidth: '400px',
                              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                              transition: 'border-color 0.3s ease',
                              placeholder: {
                                color: 'gray',             // heller Placeholder
                              }
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#4f5b77'}
                            onBlur={(e) => e.target.style.borderColor = '#3a3f54'}
                            id="43587ßß0ß91231232189809ßß1249087124"
                          />



                  </div>
                  <div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "space-evenly"}}>
                            <div onClick={() => {
                                setc(false)


                            }}><Stylebutton buttonText={"Abbrechen"}></Stylebutton></div>
                            <div 
                            onClick={() => {
                                console.log(document.getElementById("43587ßß0ß91231232189809ßß1249087124").value)
                                if (document.getElementById("43587ßß0ß91231232189809ßß1249087124").value != ""){
                                    create(document.getElementById("43587ßß0ß91231232189809ßß1249087124").value);
                                }


                            }}


                            ><Stylebutton buttonText={"Speichern"}></Stylebutton></div>
                  </div>

                </div>
  )
}

export default CreateKathegorieForm
